/* eslint-disable import/no-dynamic-require */
import React from "react"
import Link from "~components/Link"
import * as style from "./Tile.module.scss"
import { LazyLoadImage } from "react-lazy-load-image-component"

import iconDefault from "./icon-default.svg"

const Tile = ({
  type, title, href, disabled, children, active, image
}) => (
  <div>
    {href
      ? (
        <Link disabled={disabled} className={`${style.tile} ${active ? style.active : ''}`} to={href}>
          {type !== undefined
          && <img className={style.icon} alt="" src={require(`./icon-${type}.svg`).default} />}
          {(type === undefined && image === undefined)
          && <img className={style.icon} alt="" src={iconDefault} />}
          {image !== undefined
            && 
              <LazyLoadImage
                className={style.image}
                src={require(`./image-${image}.png`).default}
                width={376}
                height={211}
              />
            }
          <h2 className={style.headline}>{title}</h2>
          {children}
        </Link>
      )
      : (
        <div disabled={disabled} className={`${style.tile} ${active ? style.active : ''}`}>
          {type !== undefined
          && <img className={style.icon} alt="" src={require(`./icon-${type}.svg`).default} />}
          {type === 'default'
          && <img className={style.icon} alt="" src={iconDefault} />}
          <h2 className={style.headline}>{title}</h2>
          {children}
        </div>
      )}
  </div>
)

export default Tile
